
import { PadelGame } from "@/models/padelGame.interface";
import { PadelPlayer } from "@/models/padelPlayer.interface";
import { PadelRules } from "@/models/padelRules.interface";
import {
    getColorCodeGroupFromPlayer,
    getPadelPlayers,
} from "@/services/americanoService";
import { getDuplicateIds, isValidMaxScore } from "@/services/htmlHelperService";
import store from "@/store/index";
import { defineComponent } from "vue";

export default defineComponent({
    data: function() {
        return {
            maxScore: 32,
            maxScoreInvalid: false,
            duplicateNameIds: [] as number[],
        };
    },
    methods: {
        onAddPlayers(): void {
            if (this.maxScoreInvalid) {
                return;
            }

            const duplicateIds = getDuplicateIds(this.getPlayers);

            if (duplicateIds.length > 0) {
                this.$data.duplicateNameIds = duplicateIds;
                return;
            }

            const isGamePrepared =
                store.getters.americanoStore.getIsGamePrepared;

            if (!isGamePrepared) {
                store.dispatch.americanoStore.prepareGames();
            }
            store.commit.americanoStore.INCREMENT_STEP();
        },
        getPlayerPlaceholder(index: number) {
            const playerNumber = Number(index) + 1;
            return "Spelare " + playerNumber;
        },
        reset() {
            store.commit.americanoStore.RESET();
            this.$data.duplicateNameIds = [];
            this.$data.maxScoreInvalid = false;
            this.$data.maxScore = 32;
        },
        onMaxScoreChange() {
            const value = this.$data.maxScore;

            if (!isValidMaxScore(value)) {
                this.maxScoreInvalid = true;
                return;
            }

            this.maxScoreInvalid = false;

            const numberValue = Number(value);
            const newRules: PadelRules = {
                ...store.getters.americanoStore.getRules,
                maxScore: numberValue,
            };
            store.commit.americanoStore.SET_RULES(newRules);
        },
        handlePlayerNameChange() {
            this.$data.duplicateNameIds = getDuplicateIds(this.getPlayers);
        },
        handleAmountOfPlayersChange() {
            const players = getPadelPlayers(this.amountOfPlayersRule);
            store.commit.americanoStore.UPDATE_PLAYERS(players);
        },
        isDuplicateName(id: number) {
            return this.$data.duplicateNameIds.includes(id);
        },
        getColorCodeGroup(player: PadelPlayer) {
            if (store.getters.americanoStore.getRules.colorCode === false) {
                return 0;
            }

            if (!store.getters.americanoStore.getIsGamePrepared) {
                return store.getters.americanoStore.getPlayers.indexOf(
                    player
                ) <= 7
                    ? 1
                    : 2;
            }

            return getColorCodeGroupFromPlayer(
                player,
                store.getters.americanoStore.getPlayers,
                store.getters.americanoStore.getGames
            );
        },
    },
    created() {
        this.$data.maxScore = store.getters.americanoStore.getRules.maxScore;
    },
    computed: {
        getPlayers() {
            return store.getters.americanoStore.getPlayers;
        },
        getAddPlayerText() {
            const isGamePrepared =
                store.getters.americanoStore.getIsGamePrepared;

            if (isGamePrepared) {
                return "Gå till matcher";
            }

            return "Lägg till spelare";
        },
        randomScheduleRule: {
            get() {
                return store.getters.americanoStore.getRules.randomSchedule;
            },
            set(value: boolean) {
                const newRules: PadelRules = {
                    ...store.getters.americanoStore.getRules,
                    randomSchedule: value,
                };
                store.commit.americanoStore.SET_RULES(newRules);
            },
        },
        amountOfPlayersRule: {
            get() {
                return store.getters.americanoStore.getRules.amountOfPlayers;
            },
            set(amount: number) {
                const colorCode =
                    Number(amount) === 8 ? false : this.colorCodeRule;

                const newRules: PadelRules = {
                    ...store.getters.americanoStore.getRules,
                    amountOfPlayers: amount,
                    colorCode: colorCode,
                };
                store.commit.americanoStore.SET_RULES(newRules);
            },
        },
        court1: {
            get() {
                const rules = store.getters.americanoStore.getRules;
                if (rules.courtNames) return rules.courtNames[0];
                return "";
            },
            set(name: string) {
                const courts = store.getters.americanoStore.getRules.courtNames;
                courts[0] = name;
                const newRules: PadelRules = {
                    ...store.getters.americanoStore.getRules,
                    courtNames: courts,
                };
                store.commit.americanoStore.SET_RULES(newRules);
            },
        },
        court2: {
            get() {
                const rules = store.getters.americanoStore.getRules;
                if (rules.courtNames) return rules.courtNames[1];
                return "";
            },
            set(name: string) {
                const courts = store.getters.americanoStore.getRules.courtNames;
                courts[1] = name;
                const newRules: PadelRules = {
                    ...store.getters.americanoStore.getRules,
                    courtNames: courts,
                };
                store.commit.americanoStore.SET_RULES(newRules);
            },
        },
        colorCodeRule: {
            get() {
                return store.getters.americanoStore.getRules.colorCode;
            },
            set(value: boolean) {
                const newRules: PadelRules = {
                    ...store.getters.americanoStore.getRules,
                    colorCode: value,
                };
                store.commit.americanoStore.SET_RULES(newRules);
            },
        },
        getIsGamePrepared() {
            return store.getters.americanoStore.getIsGamePrepared;
        },
    },
});
